import { sendlicensedata, mandant, modules } from "./generalType"


// Default global state
export interface CredentialState {
    model:{
        license:sendlicensedata,
        mandant:mandant[],
        modules: modules[],
        selected: string[],
        // The hub default for an empty tolerance; null until the hub said.
        toleranceDefault: number | null,
        }
    view:{
        loginStatus: boolean, 
        role: string,
    }
}

// initialise the default values
export const CredFormInitialState : CredentialState = {
    model:{
        license:
        {
            expirationDate: "",
            numberOfTargets: 0,
            mandant: "",
            // "release" (05.10.2026): "dev" is no branch the hub knows - it fell
            // back to release anyway; the branch selection is switched off.
            branch:"release",
            edition:"free",
            software:"Vodin",
            licensedTo:"",
            module:[] as string[],
            targetTolerancePercent: null,
        },
        mandant:[] as mandant[],
        modules:[] as modules[],
        selected:[] as string[],
        toleranceDefault: null,
    },
    view:{
        loginStatus: false, 
        role: "",
    }
}

export function deepCopyChangeJob(toCopy:CredentialState,payload:any, modus:string):CredentialState{
    const deepCopy = deepCopyTableThingyState(toCopy);
    if (modus === "add")
    {
        deepCopy.model.selected.push(payload);
    }
    if (modus === "remove")
    {
     const index:number = deepCopy.model.selected.indexOf(payload);
        if (index !== -1) {
           deepCopy.model.selected.splice(index, 1);
        }    
    } 
    return deepCopy;
}

//write a deep for all state related variables
export function deepCopyTableThingyState(toCopy:CredentialState):CredentialState{
    return {
        model:{
            license:{    
                expirationDate: toCopy.model.license.expirationDate,
                numberOfTargets: toCopy.model.license.numberOfTargets,
                mandant: toCopy.model.license.mandant,            
                branch: toCopy.model.license.branch,
                edition: toCopy.model.license.edition,                
                software:toCopy.model.license.software,
                licensedTo: toCopy.model.license.licensedTo,    
                module: [...(toCopy.model.license.module ?? [])],
                targetTolerancePercent: toCopy.model.license.targetTolerancePercent ?? null,
            },
            mandant:toCopy.model.mandant.map((mandant) =>
            {
                return {
                    ...mandant,
                }
            }),
            modules:toCopy.model.modules.map((modules) =>
            {
                return {
                    ...modules,
                }
            }),
            // Eine eigene Liste, nicht dieselbe: deepCopyChangeJob haengt mit
            // push und splice daran, und bei einer geteilten Referenz
            // veraenderte das den vorherigen Zustand gleich mit - React sieht
            // dann keinen Unterschied und zeichnet nicht neu.
            selected:[...toCopy.model.selected],
            toleranceDefault:toCopy.model.toleranceDefault,
        },
        view:{
            loginStatus:toCopy.view.loginStatus,
            role:toCopy.view.role,
        }
    }
    
}

/**
 * What the tolerance field holds, as the hub wants it: a whole number within
 * 0..100, or null for the hub default. Anything else - empty, not a number,
 * out of range - is null, so the form can never send a value the hub refuses.
 */
export function toleranceFromInput(value:unknown):number | null {
    if (value === null || value === undefined || value === "") return null;
    const n = typeof value === "number" ? value : Number(value);
    return Number.isInteger(n) && n >= 0 && n <= 100 ? n : null;
}

/** Placeholder of the tolerance field: the hub default once known. */
export function tolerancePlaceholder(defaultLabel:string, hubDefault:number | null):string {
    return hubDefault === null ? defaultLabel : defaultLabel + ": " + hubDefault;
}
